import { render } from "./Schedules.vue?vue&type=template&id=1b523b9c"
import script from "./Schedules.vue?vue&type=script&lang=js"
export * from "./Schedules.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__